module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-card', {
    staticClass: "auth-view"
  }, [_c('img', {
    staticStyle: {
      "margin": "0 auto",
      "display": "block",
      "width": "100%"
    },
    attrs: {
      "src": "https://pbs.twimg.com/media/CPB2xJ9WcAAK0G6.jpg"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h1', [_vm._v("Say the password")]), _vm._v(" "), _c('record-button', {
    on: {
      "recorded": _vm.onRecord
    }
  }), _vm._v(" "), _c('br')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b3105d00!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Authentication.vue
// module id = 103
// module chunks = 2